import clsx from 'clsx';
import React, { useMemo } from 'react';

import { useInbox } from '@/src/components/project/Inbox2/store/inbox.store';
import { FileEntry, InboxEntryStatus } from '@/src/components/project/Inbox2/types';

import ConnectedApp from './ConnectedApp/ConnectedApp';
import CreateTreatment from './CreateTreatment/CreateTreatment';

import { useGetAutomationEnabled } from '../../api/getAutomationEnabled';
import AutomationButton from '../../components/Automation/AutomationButton';

type ActionHeaderProps = {
  fileEntry: FileEntry;
  hasPublishedTreatment: boolean;
  onClickAutomate?: () => void;
};

const ActionHeader: React.FC<ActionHeaderProps> = ({
  fileEntry,
  hasPublishedTreatment,
  onClickAutomate,
}) => {
  const { isTransactionsEnabled, isTreatmentHidden = false } = useInbox();
  const { status: fileEntryStatus, id: inboxDocumentId, isMultiPagePdf } = fileEntry;

  const { data: automationData } = useGetAutomationEnabled({
    inboxDocumentId,
    config: {
      enabled: !isTreatmentHidden,
    },
  });

  const isAutomationDisabled = !(automationData?.isEnabled ?? true);

  const isAutomationHidden = useMemo(
    () => hasPublishedTreatment || fileEntryStatus === InboxEntryStatus.Closed,
    [hasPublishedTreatment, fileEntryStatus]
  );

  return (
    <div
      className={clsx(
        'treatmentHeader--container',
        'tw-flex tw-items-center',
        'tw-px-[25px]',
        '-tw-mt-[10px]',
        'tw-h-[62px]',
        isTransactionsEnabled ? 'tw-justify-between' : 'tw-justify-end'
      )}
    >
      <div className="tw-flex">
        {isTransactionsEnabled && <CreateTreatment isTreatmentHidden={isTreatmentHidden} />}

        {isTransactionsEnabled && !isAutomationHidden && !isTreatmentHidden && (
          <AutomationButton
            disabled={isAutomationDisabled}
            onClickAutomate={onClickAutomate ?? (() => {})}
            isMultiPagePdf={isMultiPagePdf}
          />
        )}
      </div>

      <ConnectedApp isAppEnabled={isTransactionsEnabled} />
    </div>
  );
};

export default ActionHeader;
